var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 m-auto" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-start" },
        [
          _c("guest-post-owner-info", {
            attrs: {
              user_data: _vm.question.owner,
              supplier_data: null,
              shared: false,
              time: _vm.question.published_at,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "p-1" }, [
        _c("div", {
          staticClass: "breakAll font-medium-4 text-dark text-bold-700",
          domProps: { innerHTML: _vm._s(_vm.question.title) },
        }),
        _vm._v(" "),
        _c("div", {
          directives: [{ name: "linkified", rawName: "v-linkified" }],
          staticClass: "breakAll pt-05 pb-05",
          domProps: { innerHTML: _vm._s(_vm.question.body) },
        }),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.question.tags, function (tag) {
            return _c("span", { staticClass: "question-tag" }, [
              _vm._v(
                "\n                   " + _vm._s(tag.name) + "\n               "
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.question.group !== null || _vm.question.supplier !== null
          ? _c(
              "div",
              [
                _c("guest-service-owner-info", {
                  attrs: {
                    group: _vm.question.group,
                    supplier: _vm.question.supplier,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between border-top pl-05 pr-05",
        },
        [
          _c("div", { staticClass: "p-05" }, [
            _c(
              "span",
              {
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.question.votesCount === 0
                        ? ""
                        : _vm.question.votesCount
                    ) +
                    " " +
                    _vm._s(
                      _vm.question.votesCount === 1
                        ? _vm.__("globals.vote")
                        : _vm.__("globals.votes")
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "p-05" }, [
            _c(
              "span",
              {
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("i", { staticClass: "fa fa-comment-o" }),
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.question.answersCount === 0
                        ? ""
                        : _vm.question.answersCount
                    ) +
                    " " +
                    _vm._s(
                      _vm.question.answersCount === 1
                        ? _vm.__("globals.answer")
                        : _vm.__("globals.answers")
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }